/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Segment_End_AriaInputs */



/**
* | output |
* | --- |
* | "Segment end point" |
*
* @param {Video_Export_Segment_End_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_segment_end_aria = /** @type {((inputs?: Video_Export_Segment_End_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Segment_End_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Point final du segment")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segmentendpunkt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punto finale del segmento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Конечная точка сегмента")
	if (locale === "es") return /** @type {LocalizedString} */ ("Punto final del segmento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("段终点")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメント終点")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंड का अंतिम बिंदु")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ponto final do segmento")
	return /** @type {LocalizedString} */ ("Segment end point")
});